import type { Theme, TypeOptions } from "react-toastify";
import { twMerge, type ClassNameValue } from "tailwind-merge";

import Icons from "assets";

type CloseButtonProps = {
  closeToast: (e: React.MouseEvent<HTMLElement>) => void;
  type: TypeOptions;
  theme: Theme;
  ariaLabel?: string;
  className?: ClassNameValue;
};

const ToastCloseButton = ({
  closeToast,
  theme: _theme, // extracted to prevent a mismatch with Toastify
  type: _type, // extracted to prevent a mismatch with Toastify
  className,
  ...rest
}: CloseButtonProps) => {
  return (
    <button
      type="button"
      aria-label="Close Toast"
      onClick={closeToast}
      className={twMerge(
        "flex items-center justify-center gap-x-1.5 font-bold border-none bg-transparent text-neutrals-900 hover:text-gray-900 active:text-gray-900 active:bg-neutrals-100 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-indigo-600 transition duration-150 ease-in-out disabled:bg-neutrals-100 disabled:text-gray-500 disabled:cursor-not-allowed shadow-none px-0 size-7 aspect-square m-4",
        className,
      )}
      {...rest}>
      <Icons.Close className="size-2.5" aria-hidden="true" focusable="false" />
    </button>
  );
};

export default ToastCloseButton;
